//image fill
//scratch off logic
//all complete
//different strokes for different folks
function scratchFunctions(slide) {
	var slide = slide || globalVar.slide;
	var settings = slide.data.scratch;
	var scratchItems = slide.$.find('.scratch__js');

	setTimeout(function () {
		if (!settings.init) scratchInit(settings, scratchItems);
		else resetScratch(scratchItems, settings);
	}, 3);
}

function scratchInit(settings, scratchItems) {
	settings.items = settings.items || {};
	settings.brushSize = settings.brushSize || 20;
	settings.fillColor = settings.fillColor || 'white';
	settings.fillImg = settings.fillImg || false;
	settings.padding = settings.padding || '0';
	settings.locked = settings.locked || false;
	settings.onComplete = settings.onComplete || function () {};
	settings.percentageToComplete = settings.percentageToComplete || 90;
	settings.onWin =
		settings.onWin ||
		function () {
			handleAnswer(true);
		};

	scratchItems.addClass('scratch-style');

	scratchItems.each(function (i, scratchItem) {
		var itemID = scratchItem.id || i + 1;

		settings.items[itemID] = settings.items[itemID] || {};
		var itemSettings = settings.items[itemID];

		itemSettings.canvasElem = document.createElement('canvas');
		var canvasElem = itemSettings.canvasElem;

		itemSettings.canvas = canvasElem.getContext('2d');
		itemSettings.completed = false;
		itemSettings.onComplete = itemSettings.onComplete || function () {};

		if (settings.lottoMode) itemSettings.lottoWinner = winningScratch(settings.lottoMode, itemID);

		$(canvasElem).addClass('canvas-style');
		$(scratchItem).parent().append(canvasElem);
		$(scratchItem).addClass('scratch-style-' + (i + 1));
		if (settings.lottoMode && winningScratch(settings.lottoMode, itemID))
			$(scratchItem).addClass('winning-scratch');

		resizeCanvas(scratchItem, settings, itemSettings);

		canvasElem.addEventListener(
			'mousemove',
			function (e) {
				handleScratch(e, scratchItem, settings, itemSettings);
			},
			false
		);

		canvasElem.addEventListener(
			'touchmove',
			function (e) {
				handleScratch(e, scratchItem, settings, itemSettings);
			},
			false
		);

		window.addEventListener('resize', function () {
			setTimeout(function () {
				resizeCanvas(scratchItem, settings, itemSettings);
			}, 3);
		});
	});
	settings.init = true;
}

function handleScratch(e, scratchItem, settings, itemSettings) {
	if (itemSettings.completed || settings.locked) return;

	var canvasElem = itemSettings.canvasElem;
	var canvas = itemSettings.canvas;
	var scratch, coords;

	if (e.type === 'touchmove') {
		e.preventDefault();
		scratch = coords = e.targetTouches[0];
	} else {
		scratch = detectLeftButton(e);
		coords = e;
	}

	if (!scratch && !settings.noClick) return;

	scratchOff(canvasElem, canvas, coords, settings);

	if (!readyToComplete(canvasElem, settings)) return;

	clearCanvas(canvasElem, canvas);

	itemSettings.completed = true;

	settings.onComplete(scratchItem);
	itemSettings.onComplete(scratchItem);

	if (settings.lottoMode && !itemSettings.lottoWinner) {
		handleAnswer(false);
	}

	if (!allScratched(settings.items, settings)) return;

	settings.onWin();
}

function resetScratch(scratchItems, settings) {
	var scratchItems = scratchItems ? scratchItems : globalVar.$curSlide.find('.scratch__js');
	var settings = settings ? settings : slides[globalVar.curSlide]['scratch'];

	scratchItems.each(function (i, scratchItem) {
		var itemID = scratchItem.id || i + 1;
		var itemSettings = settings.items[itemID];

		itemSettings.completed = false;

		resizeCanvas(scratchItem, settings, itemSettings);
	});
}

function allScratched(itemsObj, settings) {
	for (var item in itemsObj) {
		var itemSettings = itemsObj[item];

		if (settings.lottoMode) {
			if (itemSettings.lottoWinner && !itemSettings.completed) return false;
		} else if (!itemSettings.completed) return false;
	}

	return true;
}
function readyToComplete(canvasElem, settings) {
	return percentComplete(canvasElem) > settings.percentageToComplete;
}
function scratchOff(canvasElem, canvas, e, settings) {
	var brushPos = getBrushPos(canvasElem, e.clientX, e.clientY);

	drawDot(canvasElem, canvas, brushPos, settings.brushSize);
}
function percentComplete(canvas) {
	var data = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data;
	var blankness = data.reduce((accumulator, currentValue) => accumulator + (currentValue === 0 ? 1 : 0));
	return (blankness * 100) / data.length;
}
function getBrushPos(canvasElem, xRef, yRef) {
	var canvasRect = canvasElem.getBoundingClientRect();
	return {
		x: Math.floor(((xRef - canvasRect.left) / (canvasRect.right - canvasRect.left)) * canvasElem.width),
		y: Math.floor(((yRef - canvasRect.top) / (canvasRect.bottom - canvasRect.top)) * canvasElem.height)
	};
}
function clearCanvas(canvasElem, canvas) {
	canvas.beginPath();
	canvas.rect(0, 0, canvasElem.width, canvasElem.height);
	canvas.fillStyle = '#000';
	canvas.fill();
}
function drawDot(canvasElem, canvas, brushPos, brushSize) {
	canvas.beginPath();
	canvas.arc(brushPos.x, brushPos.y, calcBrushSize(canvasElem.width, brushSize), 0, 2 * Math.PI, true);
	canvas.fillStyle = '#000';
	canvas.globalCompositeOperation = 'destination-out';
	canvas.fill();

	// var img = document.getElementById('stroke');
	// canvas.translate(brushPos.x + 20, brushPos.y + 10);
	// canvas.rotate((2 * Math.PI) / 180);
	// canvas.translate((brushPos.x + 20) * -1, (brushPos.y + 10) * -1);
	// canvas.drawImage(img, brushPos.x, brushPos.y, 40, 20);
}
function resizeCanvas(scratchItem, settings, itemSettings) {
	var canvasElem = itemSettings.canvasElem;
	var canvas = itemSettings.canvas;

	$(canvasElem).css('top', scratchItem.offsetTop);
	$(canvasElem).css('left', scratchItem.offsetLeft);
	canvas.canvas.width = scratchItem.offsetWidth;
	canvas.canvas.height = scratchItem.offsetHeight;

	if (!itemSettings.completed) resetCanvas(settings, itemSettings);
}
function resetCanvas(settings, itemSettings) {
	var canvasElem = itemSettings.canvasElem;
	var canvas = itemSettings.canvas;
	var fillColor = itemSettings.fillColor || settings.fillColor;
	var fillImg = itemSettings.fillImg || settings.fillImg;

	canvasFillColor(canvasElem, canvas, fillColor);
	if (fillImg) canvasImg(canvasElem, canvas, fillImg, settings, itemSettings);
}
function detectLeftButton(event) {
	if ('buttons' in event) {
		return event.buttons === 1;
	} else if ('which' in event) {
		return event.which === 1;
	} else {
		return event.button === 1;
	}
}
function calcBrushSize(canvasWidth, brushSize) {
	return (canvasWidth / 100) * brushSize;
}
function winningScratch(lottoAnswers, itemID) {
	return lottoAnswers.some(function (id) {
		return id === itemID;
	});
}

function canvasFillColor(canvasElem, canvas, color) {
	canvas.beginPath();
	canvas.rect(0, 0, canvasElem.width, canvasElem.height);
	canvas.fillStyle = color;
	canvas.globalCompositeOperation = 'source-over';
	canvas.fill();
}

function canvasImg(canvasElem, canvas, imgPath, settings, itemSettings) {
	var img = new Image();

	canvas.drawImage(img, 10, 10);

	img.onload = function () {
		var measurements = calcMeasurements(canvasElem, img, settings, itemSettings);

		canvas.drawImage(img, measurements.x, measurements.y, measurements.width, measurements.height);
	};

	img.src = imgPath;
}

function calcMeasurements(canvasElem, img, settings, itemSettings) {
	var x, y;

	var pos = parsePositioning(canvasElem, settings, itemSettings);
	var padding = parsePadding(canvasElem, settings.padding, itemSettings.padding);
	var desiredDimensions = parseDimensions(canvasElem, img, settings, itemSettings);
	var availableDimensions = {
		width: canvasElem.width - (padding.right + padding.left),
		height: canvasElem.height - (padding.top + padding.bottom)
	};
	var combinedDimensions = combineDimensions(availableDimensions, desiredDimensions);
	var dimensions = calcWidthHeight(combinedDimensions.width, combinedDimensions.height, img);

	x = parsePosition(pos.left, calcMiddle(availableDimensions.width, dimensions.width) + padding.left);
	y = parsePosition(pos.top, calcMiddle(availableDimensions.height, dimensions.height) + padding.top);

	return {
		x: x,
		y: y,
		height: dimensions.height,
		width: dimensions.width
	};
}

function parsePositioning(canvasElem, settings, itemSettings) {
	var topPercentage = parsePosition(itemSettings.top, settings.top);
	var leftPercentage = parsePosition(itemSettings.left, settings.left);

	return {
		top: topPercentage !== undefined ? canvasElem.height * (topPercentage / 100) : undefined,
		left: leftPercentage !== undefined ? canvasElem.width * (leftPercentage / 100) : undefined
	};
}
function parsePosition(pos1, pos2) {
	if (pos1 !== undefined) {
		return pos1;
	} else if (pos2 !== undefined) {
		return pos2;
	} else return undefined;
}

function combineDimensions(availableDimensions, desiredDimensions) {
	return {
		width:
			desiredDimensions.width <= availableDimensions.width ? desiredDimensions.width : availableDimensions.width,
		height:
			desiredDimensions.height <= availableDimensions.height
				? desiredDimensions.height
				: availableDimensions.height
	};
}

function parseDimensions(canvasElem, img, settings, itemSettings) {
	var dimensions;
	var width = itemSettings.width || settings.width;
	var height = itemSettings.height || settings.height;

	if (!width && !height) {
		dimensions = { width: canvasElem.width, height: canvasElem.height };
	} else if (width && !height) {
		var desiredWidth = canvasElem.width * (width / 100);
		dimensions = resizeDimension(desiredWidth, img);
	} else if (height && !width) {
		var desiredHeight = canvasElem.height * (height / 100);
		dimensions = resizeDimension(desiredHeight, img);
	} else {
		dimensions = { width: width, height: height };
	}
	return dimensions;
}

function resizeDimension(desiredDimension, img) {
	var dimensions = {};
	var percentageLarger = calcPercentageLarger(desiredDimension, img.width);

	if (percentageLarger > 0) {
		dimensions.width = decreaseByPercentage(img.width, percentageLarger);
		dimensions.height = decreaseByPercentage(img.height, percentageLarger);
	} else {
		dimensions.width = -increaseByPercentage(img.width, percentageLarger);
		dimensions.height = -increaseByPercentage(img.height, percentageLarger);
	}

	return dimensions;
}

function calcWidthHeight(availableWidth, availableHeight, img) {
	var dimensions = {};
	var percentageWider = calcPercentageLarger(availableWidth, img.width);
	var percentageTaller = calcPercentageLarger(availableHeight, img.height);

	if (percentageWider > 0 && percentageTaller > 0) {
		var greaterPercentage = percentageTaller > percentageWider ? percentageTaller : percentageWider;
		dimensions.width = decreaseByPercentage(img.width, greaterPercentage);
		dimensions.height = decreaseByPercentage(img.height, greaterPercentage);
	} else if (percentageWider > 0) {
		dimensions.width = decreaseByPercentage(img.width, percentageWider);
		dimensions.height = decreaseByPercentage(img.height, percentageWider);
	} else if (percentageTaller > 0) {
		dimensions.width = decreaseByPercentage(img.width, percentageTaller);
		dimensions.height = decreaseByPercentage(img.height, percentageTaller);
	} else {
		var smallerPercentage = percentageTaller < percentageWider ? percentageTaller : percentageWider;
		dimensions.width = -increaseByPercentage(img.width, smallerPercentage);
		dimensions.height = -increaseByPercentage(img.height, smallerPercentage);
	}

	return dimensions;
}

function calcPercentageLarger(num1, num2) {
	return ((num2 - num1) / num2) * 100;
}
function decreaseByPercentage(num, percentage) {
	return num - (num / 100) * percentage;
}
function increaseByPercentage(num, percentage) {
	return num + (num / 100) * percentage;
}
function calcMiddle(num1, num2) {
	return num1 / 2 - num2 / 2;
}
function parsePadding(canvasElem, masterPadding, itemPadding) {
	var paddingToParse = itemPadding || masterPadding;
	var padding;

	var paddingArr = paddingToParse.split(' ').map(function (pad) {
		return parseInt(pad) / 100;
	});
	switch (paddingArr.length) {
		case 2:
			padding = {
				top: canvasElem.height * paddingArr[0],
				right: canvasElem.width * paddingArr[1],
				bottom: canvasElem.height * paddingArr[0],
				left: canvasElem.width * paddingArr[1]
			};
			break;
		case 3:
			padding = {
				top: canvasElem.height * paddingArr[0],
				right: canvasElem.width * paddingArr[1],
				bottom: canvasElem.height * paddingArr[2],
				left: canvasElem.width * paddingArr[1]
			};
			break;
		case 4:
			padding = {
				top: canvasElem.height * paddingArr[0],
				right: canvasElem.width * paddingArr[1],
				bottom: canvasElem.height * paddingArr[2],
				left: canvasElem.width * paddingArr[3]
			};

			break;
		default:
			padding = {
				top: canvasElem.height * paddingArr[0],
				right: canvasElem.width * paddingArr[0],
				bottom: canvasElem.height * paddingArr[0],
				left: canvasElem.width * paddingArr[0]
			};

			break;
	}
	return padding;
}
